var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consultation-button",on:{"click":_vm.openModal}},[_c('IconComponent',{attrs:{"name":"phone"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consultation-button__text"},[_c('span',[_vm._v("Консультация")])])
}]

export { render, staticRenderFns }